// extracted by mini-css-extract-plugin
export var author = "style-mod--author--86251";
export var clipStar = "style-mod--clip-star--f29bf";
export var content = "style-mod--content--12691";
export var h6Pink = "style-mod--h6-pink--2efd3";
export var occupation = "style-mod--occupation--abcb8";
export var occupationPink = "style-mod--occupation-pink--3868a";
export var quote = "style-mod--quote--0a7c7";
export var quoteContainer = "style-mod--quote-container--470c0";
export var quoteVideoContainer = "style-mod--quote-video-container--00e31";
export var review = "style-mod--review--b06a9";
export var reviewsContainer = "style-mod--reviews-container--170a3";
export var sectionBackground = "style-mod--section-background--c5e52";
export var smallVideo = "style-mod--small-video--d1ec0";
export var starWrapper = "style-mod--star-wrapper--e237b";
export var text = "style-mod--text--d0453";
export var textRegular = "style-mod--text-regular--1d5d9";
export var title = "style-mod--title--04dc0";
export var user = "style-mod--user--e49dc";
export var videoContainer = "style-mod--video-container--12211";